import { useTranslation } from 'react-i18next';

import { useAlertDialog } from '@/components/ui/alert-dialog';
import { useAbility } from '@/hooks/ability';
import api from '@/services/api/api';
import exceptionHandler from '@/services/exceptions';
import PermissionGroupFormData from '@/types/PermissionGroup/PermissionGroupFormData';
import { useMutation } from '@tanstack/react-query';

export const useStorePermissionGroupMutation = () => {
  const { alert } = useAlertDialog();
  const { t } = useTranslation();

  const ability = useAbility();

  return useMutation({
    mutationFn: async (data: PermissionGroupFormData) => {
      if (!ability.can('admin.group.store', '')) {
        return alert({
          title: t('no-permission'),
          description: t('you-dont-have-permission-to-do-that'),
          type: 'error',
        });
      }
      const response = await api.post(`admin/group`, data);
      return response.data;
    },
    mutationKey: ['storePermissionGroup'],
  });
};
